import React from 'react';
import GraphComponent from '../Graph/GraphComponent';
import Loading from '~/FielderElements/Loading/Loading';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { DashboardPaper, DashboardSectionTitle } from './Dashboard.mui';
import { SmartActionLabel } from '~/FielderElements/SmartTaskTable/SmartStyles';

const TaskCompanyBranchGraph = (
  {
    lan,
    renderGraphPieComponent,
    chartDataPie,
    tasksCompanyPieParams,
    totalCountGraph,
    isClient,
    ...props
  }) => {
  return (
    <DashboardPaper
      variant="outlined"
      sx={{
        minHeight: isClient ? 846 : 630,
        justifyContent: 'flex-start',
        gap: 2,
      }}
    >
      <DashboardSectionTitle>{lan.serviceStatus}</DashboardSectionTitle>
      {renderGraphPieComponent ? (
        <Stack spacing={2} alignItems="center" sx={{ flexGrow: 1 }}>
          <GraphComponent
            {...props}
            lan={lan}
            type='pieDashboard'
            data={chartDataPie}
            params={tasksCompanyPieParams}
          />
          <Typography sx={{ fontSize: 17 }}>
            {`${totalCountGraph} ${lan.tasks}`}
          </Typography>
        </Stack>
      ) : (
        <Stack spacing={1} alignItems="center" justifyContent="center" sx={{ flexGrow: 1 }}>
          <Loading inline size="40px" thickness={1} />
          <SmartActionLabel variant='caption'>{lan.loading}</SmartActionLabel>
        </Stack>
      )}
    </DashboardPaper>
  );
};

export default TaskCompanyBranchGraph;
//Original code:
/*import React, { Component } from 'react';
import GraphComponent from '../Graph/GraphComponent';
import Loading from '~/FielderElements/Loading/Loading';
import Grid from '@mui/material/Grid2'
class TaskCompanyBranchGraph extends Component {
	render() {
		return (
			<Grid container className={this.props.isClient ? 'Dashboard-taskCompanyBranchGraph-Client Dashboard-box' : 'Dashboard-taskCompanyBranchGraph Dashboard-box'}>
				<Grid container className='Dashboard-box-content-graph mt-4'>
					<div className='col-auto'>
						<p className='Dashboard-box-title'>{this.props.lan.serviceStatus}</p>
					</div>
					{this.props.renderGraphPieComponent ? (
						<>
							<GraphComponent
								{...this.props}
								type='pieDashboard'
								data={this.props.chartDataPie}
								params={this.props.tasksCompanyPieParams}
							/>
							<div className='row d-flex justify-content-center mt-2'>
								<p className='textTotalCount-graph mb-0'>{`${this.props.totalCountGraph} ${this.props.lan.tasks}`}</p>
							</div>
						</>
					) : (
						<div className='row'>
							<div className='col-12 d-flex justify-content-center no-padding marginLoadingGraphTask'>
                <Loading inline size="40px" thickness={1} />
              </div>
							<div className='col d-flex justify-content-center no-padding'>{this.props.lan.loading}</div>
						</div>
					)}
				</Grid>
			</Grid>
		);
	}
}
export default TaskCompanyBranchGraph;
*/
